import { UseFormReturn } from 'react-hook-form'
import { z } from 'zod'

import FormInput from '@/components/form/formInput'

// eslint-disable-next-line react-refresh/only-export-components
export const unitPriceSchema = z.object({
    units: z.coerce.number({ message: 'Enter a number' }).positive('Must be a positive number'),
    price: z.coerce.number({ message: 'Enter a number' }).positive('Must be a positive number'),
})
type UnitPriceSchemaType = z.infer<typeof unitPriceSchema>

interface Props {
    form: UseFormReturn<UnitPriceSchemaType>
}

const calculateTotal = (units: number, price: number) => {
    try {
        const total = units * price
        return isNaN(total) ? 0 : total
    } catch (error) {
        return 0
    }
}

export default function CreateOrderUnitPriceForm({ form }: Props) {
    const units = form.watch('units')
    const price = form.watch('price')
    const total = calculateTotal(units, price)
    return (
        <div className="flex gap-4 mt-4">
            <FormInput type="number" control={form.control} name="units" label="Units" className="w-32" />
            <span className="self-end pb-2 font-mono">@</span>
            <FormInput type="number" control={form.control} name="price" label="Price" className="w-32" />
            <div className="self-end flex-grow pb-2 font-mono text-right truncate max-w-32">
                {!!total && <span className="pb-2 text-subtext0">${total}</span>}
            </div>
        </div>
    )
}
